module.exports = __webpack_public_path__ + "static/media/rebirth_sample_1.ebcd62c8.jpg";